import React from 'react';

/**
 * Calculates if the content is overflowing it element containing it
 * @param element - the DOM element which has a clientWidth and scrollWidth props
 * @returns {boolean} - True, if the content is overflowing, false otherwise.
 * @example
 * import { isContentOverflowingElement } from '@adsk/alloy-react-helpers';
 *
 * const ref = useRef<HTMLDivElement>(null);
 * const overflowed = isContentOverflowingElement(ref);
 * @see Tooltip
 */
export default function isContentOverflowingElement<T extends HTMLElement>(
  ref: React.RefObject<T>,
) {
  const target = ref?.current;
  if (target) {
    if (!('scrollWidth' in target)) {
      throw new Error('Element does not have a scrollWidth property');
    }

    if (!('offsetWidth' in target)) {
      throw new Error('Element does not have a offsetWidth property');
    }

    if (!('scrollHeight' in target)) {
      throw new Error('Element does not have a scrollHeight property');
    }

    if (!('offsetHeight' in target)) {
      throw new Error('Element does not have a offsetHeight property');
    }

    return (
      target.scrollWidth > target.offsetWidth ||
      target.scrollHeight > target.offsetHeight
    );
  }

  return false;
}
